import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { useDexieQuery } from '@/hooks/use-dexie-query'
import { Spinner } from '@/components/spinner'
import { useMyRole } from '@/features/auth/hooks/use-my-role'

export const Route = createFileRoute('/_authenticated/f/$fotoInterventoId')({
  component: RouteComponent,
  ssr: false,
})

function RouteComponent() {
  const { fotoInterventoId } = Route.useParams()
  const navigate = Route.useNavigate()
  const myRole = useMyRole()

  // Fetch the foto intervento to get the intervento_id
  const fotoIntervento = useDexieQuery((db) =>
    db.foto_interventi.get(fotoInterventoId)
  )

  useEffect(() => {
    if (fotoIntervento && myRole !== undefined) {
      // Determine the target route based on user role
      const targetRoute =
        myRole === 'committente'
          ? '/interventi/visualizza/$interventoId'
          : '/interventi/modifica/$interventoId'

      // Navigate to the appropriate route with photo modal parameters
      navigate({
        to: targetRoute,
        params: { interventoId: fotoIntervento.intervento_id! },
        search: {
          fotoModalOpen: true,
          fotoModalId: fotoInterventoId,
        },
        replace: true, // Replace the current history entry
      })
    }
  }, [fotoIntervento, myRole, navigate, fotoInterventoId])

  // Show loading spinner while fetching data
  if (!fotoIntervento || myRole === undefined) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <Spinner size="large" />
          <p className="text-muted-foreground mt-4">Caricamento...</p>
        </div>
      </div>
    )
  }

  // This should not be reached as we redirect in useEffect
  return null
}
